import { useQuery } from '@tanstack/react-query';
import { userService } from '../../services/user.service';
import { queryKeys } from '../../lib/query-keys';

export function useOrgUsers(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.users.all(orgId ?? ''),
    queryFn: () => userService.getUsers(1, 100, { status: 'active' }),
    enabled: !!orgId,
    staleTime: 5 * 60_000,
    select: (res) => {
      const raw = (res as any).data;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}
